import {
  FETCH_PREINVOICE_REQUEST,
  FETCH_PREINVOICE_SUCCESS,
  FETCH_PREINVOICE_FAILURE,
} from "./CreateInvoicePreDataTypes";

const initialState = {
  loading: false,
  preInvoiceList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PREINVOICE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PREINVOICE_SUCCESS:
      return {
        loading: false,
        preInvoiceList: action.payload,
        error: "",
      };
    case FETCH_PREINVOICE_FAILURE:
      return {
        loading: false,
        preInvoiceList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
